// libs
import get from 'lodash/get';

// constants
import { WIDGET_TYPES } from 'shared/layouts/DetailsPage/constants';

// helpers
import { storeAnalyticsDataInLocal } from 'shared/helpers/storage/storeData';
import { SEO_IMAGE_ATTRIBUTES } from 'shared/layouts/DetailsPage/components/ProductImage/Media/constants';

interface IImagesViewedObject {
  imagesViewed: number[];
  totalImages: number;
  productId: string;
}

export const hasSimilarWidget = (widgetData: { relatedProducts: { widget_type: string }[] }) => {
  const similarProductWidget = get(widgetData, 'relatedProducts', []).find(
    (widget) => widget.widget_type === WIDGET_TYPES.SIMILAR_PRODUCTS
  );
  return similarProductWidget !== undefined;
};

let imagesViewedObject: IImagesViewedObject = {
  productId: '',
  imagesViewed: [],
  totalImages: 0,
};

export const getImageMeta = (productTitle: string, productSubTitle: string) => {
  const altText =
    `${SEO_IMAGE_ATTRIBUTES.IMAGE_ALT_PREFIX} ${productTitle} ${productSubTitle} ${SEO_IMAGE_ATTRIBUTES.IMAGE_ALT_SUFFIX}`.trim();

  const titleText =
    `${SEO_IMAGE_ATTRIBUTES.IMAGE_TITLE_PREFIX} ${productTitle} ${productSubTitle} ${SEO_IMAGE_ATTRIBUTES.IMAGE_TITLE_SUFFIX}`.trim();

  return { altText, titleText };
};
export const storeViewedImagesOnLocal = () => {
  const imagesViewData = { ...imagesViewedObject };
  storeAnalyticsDataInLocal(imagesViewData);
};

export const clearImagesViewed = () => {
  imagesViewedObject.imagesViewed = [0];
  imagesViewedObject.totalImages = 0;
  imagesViewedObject.productId = '';
};

export const saveImageData = (imagePosition: number, totalImages: number, productId: string) => {
  const { imagesViewed } = imagesViewedObject;

  imagesViewedObject.totalImages = totalImages;
  imagesViewedObject.productId = productId;

  if (!imagesViewed.includes(imagePosition)) {
    imagesViewed.push(imagePosition);
    imagesViewed.sort();
    imagesViewedObject.imagesViewed = imagesViewed;
    storeViewedImagesOnLocal();
  }
};
